import { render } from "./ModalSuccess.vue?vue&type=template&id=051b554b&scoped=true"
import script from "./ModalSuccess.vue?vue&type=script&lang=js"
export * from "./ModalSuccess.vue?vue&type=script&lang=js"

import "./ModalSuccess.vue?vue&type=style&index=0&id=051b554b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051b554b"]])

export default __exports__